module.exports = __webpack_public_path__ + "static/media/Group 1896.69e3bae8.jpeg";